import http from "../http-common";
import httpMultipart from "../http-multipart";

class AttendanceService {
    getAll() {
        return http.get("/grade");
    }
    checkAbsentDate(date, idClass){
        return http.get(`/attendance-kids/check-absent-status?date=${date}&idClass=${idClass}`);
    }
    getConfigCommonForAttendance() {
        return http.get(`/attendance-kids/config/pickup-kid`);
    }
    searchAllService(date, idClass, absentStatus, attendanceStatus) {
        return http.get(`/attendance-kids/search?date=${date}&idClass=${idClass}&absentStatus=${absentStatus}&attendanceStatus=${attendanceStatus}`);
    }
    searchArriveDate(date, idClass, absentStatus, attendanceStatus) {
        return http.get(`/attendance-kids/search/arrive?date=${date}&idClass=${idClass}&absentStatus=${absentStatus}&attendanceStatus=${attendanceStatus}`);
    }
    searchLeaveDate(date, idClass, absentStatus) {
        return http.get(`/attendance-kids/search/leave?date=${date}&idClass=${idClass}&absentStatus=${absentStatus}`);
    }
    searchEatDate(date, idClass, absentStatus) {
        return http.get(`/attendance-kids/search/eat?date=${date}&idClass=${idClass}&absentStatus=${absentStatus}`);
    }
    getArriveByIdKidOfMonth(idKid, month, year) {
        return http.get(`/attendance-kids/arrive/month/${idKid}?month=${month}&year=${year}`);
    }
    getLeaveByIdKidOfMonth(idKid, month, year) {
        return http.get(`/attendance-kids/leave/month/${idKid}?month=${month}&year=${year}`);
    }
    getEatByIdKidOfMonth(idKid, month, year) {
        return http.get(`/attendance-kids/eat/month/${idKid}?month=${month}&year=${year}`);
    }
    saveArriveOne(id, data) {
        return http.post(`/attendance-kids/arrive/${id}`, data);
    }
    saveArriveOneV2(id, data) {
        return http.post(`/attendance-kids/v2/${id}`, data);
    }
    saveArriveManyV2(data) {
        return http.post(`/attendance-kids/v2/many`, data);
    }
    updateArriveContent(id, data) {
        return httpMultipart.post(`/attendance-kids/arrive-content/${id}`, data);
    }
    updateArriveContentV2(id, data) {
        return httpMultipart.post(`/attendance-kids/v2/content/${id}`, data);
    }
    updateLeaveContent(id, data) {
        return httpMultipart.post(`/attendance-kids/leave-content/${id}`, data);
    }
    saveLeaveOne(id, data) {
        return http.post(`/attendance-kids/leave/${id}`, data);
    }
    saveEatOne(id, data) {
        return http.post(`/attendance-kids/eat/${id}`, data);
    }
    saveArriveMany(data) {
        return http.post(`/attendance-kids/arrive/many`, data);
    }
    saveLeaveMany(data) {
        return http.post(`/attendance-kids/leave/many`, data);
    }
    saveEatMany(data) {
        return http.post(`/attendance-kids/eat/many`, data);
    }
    getCalendarClass(idClass) {
        return http.get(`/attendance-kids/class/dayOff/view/${idClass}`);
    }
    //export excel
    getExportExcelDate(idClass,date){
        return http.get(`/attendance-kids/export-attendance-kid-new?idClass=${idClass}&date=${date}`);
    }
    getExportExcelDateV2(idClass,date){
        return http.get(`/attendance-kids/export-attendance-kid-new/v2?idClass=${idClass}&date=${date}`);
    }
    getExportExcelMonth(idClass,date){
        return http.get(`/attendance-kids/export-attendance-kid-month-new?idClass=${idClass}&date=${date}`);
    }
    getExportExcelMonthV2(idClass,date){
        return http.get(`/attendance-kids/export-attendance-kid-month-new/v2?idClass=${idClass}&date=${date}`);
    }

    getExportExcelCustom(dateStartEnd, idClass, status){
        return http.get(`attendance-kids/export-attendance-kid-custom-new?dateStartEnd=${dateStartEnd}&idClass=${idClass}&status=${status}`);
    }
    getExportExcelCustomV2(dateStartEnd, idClass, status){
        return http.get(`attendance-kids/export-attendance-kid-custom-new/v2?dateStartEnd=${dateStartEnd}&idClass=${idClass}&status=${status}`);
    }
    getExportExcelMonthDetail(dateStartEnd, idClass, status){
        return http.get(`attendance-kids/export-attendance-kid-custom-detail?dateStartEnd=${dateStartEnd}&idClass=${idClass}&status=${status}`);
    }

    getExportExcelMonthDetailOld(dateStartEnd, idClass, status){
        return http.get(`attendance-kids/export-attendance-kid-custom-detailOld?dateStartEnd=${dateStartEnd}&idClass=${idClass}&status=${status}`);
    }
}

export default new AttendanceService();